module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/72.d0577a4f.png";